export default __webpack_public_path__ + "static/media/614.648bbc8f.png";